import { TokenAvatar } from '@/ui/Avatars/TokenAvatar';

import { fontStyles } from '../../../styles/typography';
import {
  MatchaTooltip,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '../../../ui/MatchaTooltip';
import { TokenResult } from '../../../utils/0x/token-registry.types';

export const TokenButton = ({ token, onClick }: { token: TokenResult; onClick(): void }) => (
  <MatchaTooltip>
    <MatchaTooltipTrigger>
      <button
        className="bg-token-gray-300 inline-flex items-center justify-center p-1.5 rounded-xl border-none transition-all duration-200 ease-in-out outline-none scale-[0.98] hover:bg-token-gray-400 active:bg-token-gray-500 focus-visible:bg-token-gray-400 focus-visible:outline-[3px] focus-visible:outline-token-gray-500 disabled:scale-100 disabled:cursor-not-allowed disabled:bg-token-gray-200"
        onClick={() => onClick()}
      >
        <TokenAvatar
          address={token.address}
          chainId={token.chainId}
          size={24}
          showChainLogo={false}
        />
      </button>
    </MatchaTooltipTrigger>
    <MatchaTooltipContent>
      <span className={fontStyles({ variant: 'BODY_SM', class: 'text-token-gray-1600' })}>
        {token.name}
      </span>
      <span className={fontStyles({ variant: 'BODY_SM', class: 'text-token-gray-700 ml-1' })}>
        {token.symbol}
      </span>
    </MatchaTooltipContent>
    <MatchaTooltipPopover sideOffset={5} />
  </MatchaTooltip>
);
